unit Login;

interface

uses
  System.SysUtils, System.Classes, Vcl.Forms, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Connection, WEBLib.ExtCtrls, WEBLib.DB, WEBLib.DBCtrls, WEBLib.Grids, TerminalForm,
  Vcl.Imaging.pngimage;

type
  TfrmLogin = class(TTerminalForm)
    lblError: TLabel;
    edtUser: TEdit;
    edtPass: TEdit;
    btnOk: TButton;
    btnDelete: TButton;
    logoimage: TImageControl;
    procedure btnOkClick(Sender: TObject);
    procedure btnDeleteClick(Sender: TObject);
    procedure FormShow(Sender: TObject);
    procedure edtUserDblClick(Sender: TObject);
  protected
    procedure ApplyTheme(Dark: boolean); reintroduce;
  private
    { Private declarations }
    FConnected: boolean;
    procedure WhenOnline(IsConnected: boolean);
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmLogin: TfrmLogin;

implementation

{$R *.dfm}

uses Main, Client.Core, Auth.Service;

procedure TfrmLogin.btnOkClick(Sender: TObject);

  procedure DisplayError(Txt: string);
  begin
    lblError.Caption := Txt;
    lblError.Show;
    edtPass.Text := '';
  end;

  procedure LoginSuccess;
  begin
    frmMain.LastUser := edtUser.Text;
    frmMain.ToggleLogoutBtn(true);
    frmMain.ShowPristanisce;
  end;

  procedure LoginError(AMsg: string);
  begin
    DisplayError(AMsg);
  end;

begin
  lblError.Hide;

  if edtUser.Text='' then begin
    DisplayError('Vpiši uporabniško ime');
    exit;
  end;

  if edtPass.Text='' then begin
    DisplayError('Vpiši geslo');
    exit;
  end;

  try
    Log('Starting login procedure...');

    AuthService.Login(edtUser.Text, edtPass.Text,
      @LoginSuccess,
      @LoginError
    );
  except
    on E:Exception do begin
      Log('Login procedure error: '+E.Message);
    end;
//    DisplayError('Ni interneta');
  end;
end;

procedure TfrmLogin.edtUserDblClick(Sender: TObject);
begin
  inherited;
//  edtUser.Text := 'admin';
//  edtPass.Text := 'test';
end;

procedure TfrmLogin.WhenOnline(IsConnected: boolean);
begin
  FConnected := IsConnected;
end;

procedure TfrmLogin.btnDeleteClick(Sender: TObject);
begin
  edtUser.Text := '';
  edtPass.Text := '';
  edtUser.SetFocus;

  lblError.Hide;
end;

procedure TfrmLogin.ApplyTheme(Dark: boolean);
begin
  inherited;
end;

procedure TfrmLogin.FormShow(Sender: TObject);
begin
  inherited;

  //imgLogoLogin.LoadFromURL('graphics/Logo.png');
  edtUser.Text := frmMain.LastUser;
  edtUser.SetFocus;
  ApplyTheme(frmMain.DarkMode);
end;

procedure TfrmLogin.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblError := TLabel.Create('lblError');
  logoimage := TImageControl.Create('logo-image');
  edtUser := TEdit.Create('edtUser');
  edtPass := TEdit.Create('edtPass');
  btnOk := TButton.Create('btnOK');
  btnDelete := TButton.Create('btnDelete');

  lblError.BeforeLoadDFMValues;
  logoimage.BeforeLoadDFMValues;
  edtUser.BeforeLoadDFMValues;
  edtPass.BeforeLoadDFMValues;
  btnOk.BeforeLoadDFMValues;
  btnDelete.BeforeLoadDFMValues;
  try
    Color := clBtnFace;
    lblError.SetParentComponent(Self);
    lblError.Name := 'lblError';
    lblError.Left := 91;
    lblError.Top := 309;
    lblError.Width := 7;
    lblError.Height := 37;
    lblError.Alignment := taCenter;
    lblError.Anchors := [akLeft,akTop,akRight];
    lblError.Color := clBtnFace;
    lblError.ElementFont := efCSS;
    lblError.ElementPosition := epIgnore;
    lblError.Font.Charset := DEFAULT_CHARSET;
    lblError.Font.Color := clRed;
    lblError.Font.Height := -27;
    lblError.Font.Name := 'Segoe UI';
    lblError.Font.Style := [];
    lblError.HeightStyle := ssAuto;
    lblError.HeightPercent := 100.000000000000000000;
    lblError.Layout := tlCenter;
    lblError.ParentFont := False;
    lblError.Visible := False;
    lblError.WidthPercent := 100.000000000000000000;
    logoimage.SetParentComponent(Self);
    logoimage.Name := 'logoimage';
    logoimage.Left := 250;
    logoimage.Top := 240;
    logoimage.Width := 96;
    logoimage.Height := 25;
    logoimage.HeightStyle := ssAuto;
    logoimage.WidthStyle := ssAuto;
    logoimage.HeightPercent := 100.000000000000000000;
    logoimage.WidthPercent := 100.000000000000000000;
    logoimage.ChildOrder := 8;
    logoimage.ElementFont := efCSS;
    logoimage.ElementPosition := epIgnore;
    edtUser.SetParentComponent(Self);
    edtUser.Name := 'edtUser';
    edtUser.Left := 168;
    edtUser.Top := 66;
    edtUser.Width := 449;
    edtUser.Height := 49;
    edtUser.AutoCompletion := acUserName;
    edtUser.CharCase := wecLowerCase;
    edtUser.ChildOrder := 6;
    edtUser.ElementFont := efCSS;
    edtUser.ElementPosition := epIgnore;
    edtUser.HeightStyle := ssAuto;
    edtUser.HeightPercent := 100.000000000000000000;
    edtUser.WidthStyle := ssAuto;
    edtUser.WidthPercent := 100.000000000000000000;
    SetEvent(edtUser, Self, 'OnDblClick', 'edtUserDblClick');
    edtPass.SetParentComponent(Self);
    edtPass.Name := 'edtPass';
    edtPass.Left := 168;
    edtPass.Top := 146;
    edtPass.Width := 449;
    edtPass.Height := 49;
    edtPass.AutoCompletion := acCurrentPassword;
    edtPass.ChildOrder := 6;
    edtPass.ElementFont := efCSS;
    edtPass.ElementPosition := epIgnore;
    edtPass.HeightStyle := ssAuto;
    edtPass.HeightPercent := 100.000000000000000000;
    edtPass.PasswordChar := '*';
    edtPass.WidthStyle := ssAuto;
    edtPass.WidthPercent := 100.000000000000000000;
    btnOk.SetParentComponent(Self);
    btnOk.Name := 'btnOk';
    btnOk.Left := 342;
    btnOk.Top := 642;
    btnOk.Width := 256;
    btnOk.Height := 86;
    btnOk.ChildOrder := 1;
    btnOk.ElementFont := efCSS;
    btnOk.ElementPosition := epIgnore;
    btnOk.Font.Charset := DEFAULT_CHARSET;
    btnOk.Font.Color := clWindowText;
    btnOk.Font.Height := -27;
    btnOk.Font.Name := 'Segoe UI';
    btnOk.Font.Style := [];
    btnOk.HeightStyle := ssAuto;
    btnOk.HeightPercent := 100.000000000000000000;
    btnOk.ParentFont := False;
    btnOk.WidthPercent := 100.000000000000000000;
    SetEvent(btnOk, Self, 'OnClick', 'btnOkClick');
    btnDelete.SetParentComponent(Self);
    btnDelete.Name := 'btnDelete';
    btnDelete.Left := 27;
    btnDelete.Top := 642;
    btnDelete.Width := 256;
    btnDelete.Height := 86;
    btnDelete.ChildOrder := 1;
    btnDelete.ElementFont := efCSS;
    btnDelete.ElementPosition := epIgnore;
    btnDelete.Font.Charset := DEFAULT_CHARSET;
    btnDelete.Font.Color := clWindowText;
    btnDelete.Font.Height := -27;
    btnDelete.Font.Name := 'Segoe UI';
    btnDelete.Font.Style := [];
    btnDelete.HeightStyle := ssAuto;
    btnDelete.HeightPercent := 100.000000000000000000;
    btnDelete.ParentFont := False;
    btnDelete.WidthPercent := 100.000000000000000000;
    SetEvent(btnDelete, Self, 'OnClick', 'btnDeleteClick');
  finally
    lblError.AfterLoadDFMValues;
    logoimage.AfterLoadDFMValues;
    edtUser.AfterLoadDFMValues;
    edtPass.AfterLoadDFMValues;
    btnOk.AfterLoadDFMValues;
    btnDelete.AfterLoadDFMValues;
  end;
end;

end.
